<template>
    <div :dusk="dusk">
        <nav class="forms__field_input--cropper__toolbar">
            <div class="forms__field_input--cropper__toolbar__level">
                <div class="forms__field_input--cropper__toolbar__section">
                    <cropper-bar-section>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.move'),
                            }"
                            @click="cropper.setDragMode('move')"
                        >
                            <icon icon="fa/regular/arrows-up-down-left-right" class="size-3" />
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.crop'),
                            }"
                            @click="cropper.setDragMode('crop')"
                        >
                            <icon icon="fa/regular/crop" class="size-3" />
                        </cropper-button>
                    </cropper-bar-section>
                    <cropper-bar-section>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.zoom-in'),
                            }"
                            @click="cropper.zoom(0.1)"
                        >
                            <icon icon="fa/regular/magnifying-glass-plus" class="size-3" />
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.zoom-out'),
                            }"
                            @click="cropper.zoom(-0.1)"
                        >
                            <icon icon="fa/regular/magnifying-glass-minus" class="size-3" />
                        </cropper-button>
                    </cropper-bar-section>
                    <cropper-bar-section>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.arrow-left'),
                            }"
                            @click="cropper.move(-10, 0)"
                        >
                            <icon icon="fa/regular/arrow-left" class="size-3" />
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.arrow-right'),
                            }"
                            @click="cropper.move(10, 0)"
                        >
                            <icon icon="fa/regular/arrow-right" class="size-3" />
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.arrow-up'),
                            }"
                            @click="cropper.move(0, -10)"
                        >
                            <icon icon="fa/regular/arrow-up" class="size-3" />
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.arrow-down'),
                            }"
                            @click="cropper.move(0, 10)"
                        >
                            <icon icon="fa/regular/arrow-down" class="size-3" />
                        </cropper-button>
                    </cropper-bar-section>
                    <cropper-bar-section>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.rotate-left'),
                            }"
                            @click="cropper.rotate(-45)"
                        >
                            <icon icon="fa/regular/rotate-left" class="size-3" />
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.rotate-right'),
                            }"
                            @click="cropper.rotate(45)"
                        >
                            <icon icon="fa/regular/rotate-right" class="size-3" />
                        </cropper-button>
                    </cropper-bar-section>
                    <cropper-bar-section>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.flip-horizontal'),
                            }"
                            @click="cropper.scaleX(-1)"
                        >
                            <icon icon="fa/regular/arrows-left-right" class="size-3" />
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.flip-vertical'),
                            }"
                            @click="cropper.scaleY(-1)"
                        >
                            <icon icon="fa/regular/arrows-up-down" class="size-3" />
                        </cropper-button>
                    </cropper-bar-section>
                    <cropper-bar-section>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.crop-it'),
                            }"
                            @click="cropper.crop()"
                        >
                            <icon icon="fa/regular/check" class="size-3" />
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.clear'),
                            }"
                            @click="cropper.clear()"
                        >
                            <icon icon="fa/regular/xmark" class="size-3" />
                        </cropper-button>
                    </cropper-bar-section>
                    <cropper-bar-section>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.disable'),
                            }"
                            @click="cropper.disable()"
                        >
                            <icon icon="fa/regular/lock" class="size-3" />
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.enable'),
                            }"
                            @click="cropper.enable()"
                        >
                            <icon icon="fa/regular/unlock" class="size-3" />
                        </cropper-button>
                    </cropper-bar-section>
                    <cropper-bar-section>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.reset'),
                            }"
                            @click="cropper.reset()"
                        >
                            <icon icon="fa/regular/rotate" class="size-3" />
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.destroy'),
                            }"
                            @click="cropper.destroy()"
                        >
                            <icon icon="fa/regular/power-off" class="size-3" />
                        </cropper-button>
                    </cropper-bar-section>
                    <cropper-bar-section>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.aspect_ratio', { ratio: '16:9' }),
                            }"
                            :active="ratio === 16 / 9"
                            @click="setAspectRatio(16 / 9)"
                        >
                            <span class="h-3 font-mono" style="font-size: 0.6em"> 16:9 </span>
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.aspect_ratio', { ratio: '4:3' }),
                            }"
                            :active="ratio === 4 / 3"
                            @click="setAspectRatio(4 / 3)"
                        >
                            <span class="h-3 font-mono" style="font-size: 0.6em"> 4:3 </span>
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.aspect_ratio', { ratio: '1:1' }),
                            }"
                            :active="ratio === 1 / 1"
                            @click="setAspectRatio(1 / 1)"
                        >
                            <span class="h-3 font-mono" style="font-size: 0.6em"> 1:1 </span>
                        </cropper-button>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.aspect_ratio', { ratio: '2:3' }),
                            }"
                            :active="ratio === 2 / 3"
                            @click="setAspectRatio(2 / 3)"
                        >
                            <span class="h-3 font-mono" style="font-size: 0.6em"> 2:3 </span>
                        </cropper-button>
                    </cropper-bar-section>
                    <cropper-bar-section>
                        <cropper-button
                            v-tooltip="{
                                position: 'bottom-left',
                                message: lang('media::media.fields.cropper.tools.save'),
                            }"
                            :highlight="hasUnsavedChanges"
                            class="px-2 space-x-1 w-fit"
                            @click="save()"
                        >
                            <icon icon="fa/regular/floppy-disk" class="size-3" />
                            <span v-if="hasUnsavedChanges" class="text-xs font-semibold">
                                {{ lang('media::media.fields.cropper.save_changes') }}
                            </span>
                        </cropper-button>
                    </cropper-bar-section>
                </div>
            </div>
        </nav>
        <div>
            <img ref="preview" :src="modelValue" class="block max-w-full" />
        </div>
        <nav class="forms__field_input--cropper__infobar">
            <div class="forms__field_input--cropper__toolbar__level">
                <div class="forms__field_input--cropper__toolbar__section" style="font-size: 0.6em">
                    <cropper-bar-section>
                        <div>{{ lang('media::media.fields.cropper.x') }} {{ info.x }}</div>
                        <div>{{ lang('media::media.fields.cropper.y') }} {{ info.y }}</div>
                    </cropper-bar-section>
                    <cropper-bar-section>
                        <div>{{ lang('media::media.fields.cropper.width') }} {{ info.width }}</div>
                        <div>{{ lang('media::media.fields.cropper.height') }} {{ info.height }}</div>
                    </cropper-bar-section>
                    <cropper-bar-section>
                        <div>{{ lang('media::media.fields.cropper.rotate') }} {{ info.rotate }}</div>
                        <div>{{ lang('media::media.fields.cropper.scaleX') }} {{ info.scaleX }}</div>
                        <div>{{ lang('media::media.fields.cropper.scaleY') }} {{ info.scaleY }}</div>
                    </cropper-bar-section>
                </div>
            </div>
        </nav>
    </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';
import CropperBarSection from '@src/Media/Pages/Fields/Cropper/CropperBarSection.vue';
import CropperButton from '@src/Media/Pages/Fields/Cropper/CropperButton.vue';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

const modelValue = defineModel({
    type: String,
});

const emit = defineEmits<{
    (event: 'cropped', data: File): void;
}>();

const props = withDefaults(defineProps<FieldComponent>(), {});

const preview = ref<HTMLElement | null>(null);
const cropper = ref<Cropper | null>(null);
const ratio = ref(null);

const info = ref({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    rotate: 0,
    scaleX: 1,
    scaleY: 1,
});

const hasUnsavedChanges = ref(false);

const initCropper = () => {
    if (preview.value && !cropper.value) {
        cropper.value = new Cropper(preview.value as HTMLImageElement, {
            // aspectRatio: ratio.value,
            autoCrop: true,
            autoCropArea: 1,
            viewMode: 1,
            ready() {
                hasUnsavedChanges.value = false;
            },
            crop(event) {
                info.value.x = event.detail.x;
                info.value.y = event.detail.y;
                info.value.width = event.detail.width;
                info.value.height = event.detail.height;
                info.value.rotate = event.detail.rotate;
                info.value.scaleX = event.detail.scaleX;
                info.value.scaleY = event.detail.scaleY;
                hasUnsavedChanges.value = true;
            },
        });
    }
};

onMounted(() => {
    initCropper();
});

watch(
    () => modelValue,
    (newVal) => {
        if (cropper.value && newVal) {
            cropper.value.replace(newVal);
        }
    },
);

/**
 * Controls
 */
const setAspectRatio = (value: number): boolean => {
    if (!cropper.value) {
        return false;
    }

    cropper.value.setAspectRatio(value);

    ratio.value = value;

    return true;
};

const save = (): void => {
    if (cropper.value) {
        cropper.value.getCroppedCanvas().toBlob((blob: Blob) => {
            emit('cropped', new File([blob], props.field?.file?.name ?? 'cropped.jpg'));

            hasUnsavedChanges.value = false;
        });
    }
};
</script>
